import styled from 'styled-components';
import { MediaQuery, NeutralColors } from 'theme';

const FinishWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const ContentLayout = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  height: 100%;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    flex-direction: column;
    overflow-y: auto;
  }
`;

const LeftContent = styled.div`
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    padding: 24px 16px;
  }
`;

const SceneImage = styled.div`
  width: 100%;
  height: 240px;
  background-position: center;
  background-size: cover;
  border-radius: 8px;
  overflow: hidden;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RightContent = styled.div`
  width: 460px;
  background-color: ${NeutralColors[10]};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  @media (max-width: ${MediaQuery.screenSizesCss.phone}) {
    width: 100%;
    padding: 24px 16px;
    overflow-y: visible;
  }
`;

export {
  ContentLayout,
  FinishWrapper,
  LeftContent,
  RightContent,
  SceneImage,
  TitleSection,
};
